module.exports = __webpack_public_path__ + "img/m_banner.acc11f56.png";